
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { BaseVue } from "@newview/base-web";
import { comForm } from "@newview/ui";
@Component({
  name: "",
  components: {
    comForm,
  },
})
export default class BusinessClass extends BaseVue {
  @Prop({ default: "" }) title!: any; //头部标题
  @Prop({ default: "" }) width!: any; //盒子宽度
  @Prop({ default: "" }) height!: any; //盒子高度
  @Prop({ default: true }) toggle!: any; //是否可折叠
  @Prop({ default: true }) isAutoFold!: any; //是否默认展开

  get boxClass() {
    let classStr = "nv-cell-box-" + this.direction;
    if (this.title === "") {
      classStr += " border-none";
    }
    return classStr;
  }

  direction = "row";
  isOpen = this.isAutoFold;
  mounted() {
    let parent: any = this.$parent;
    this.direction = parent.direction;
    if (this.direction == "row") {
      if (!this.width) {
        this.toggle = false;
      }
    } else {
      if (!this.height) {
        this.toggle = false;
      }
    }
  }
  loadCellStyle() {
    if (this.direction == "row") {
      return {
        width: this.isOpen ? this.width : "32px",
        flex: this.width ? "initial" : 1,
      };
    } else {
      return {
        height: this.isOpen ? this.height : "32px",
        flex: this.height ? "initial" : 1,
      };
    }
  }
  toggleCell() {
    this.isOpen = !this.isOpen;
    this.$emit("toggle", this.isOpen);
  }
}
